import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import Handlebars from '@sparta.global.vendors/handlebars';
import { contains } from '@sparta.global.helpers/comparisons-helper/dist/es6.js';
import { picture } from '@sparta.global.helpers/picture-helper/dist/es6.js';

const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"contains")||(depth0 && lookupProperty(depth0,"contains"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"category") : depth0),((stack1 = (depths[1] != null ? lookupProperty(depths[1],"page") : depths[1])) != null ? lookupProperty(stack1,"category") : stack1),{"name":"contains","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":2},"end":{"line":28,"column":15}}})) != null ? stack1 : "");
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <div class=\"row "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"images") : depth0)) != null ? lookupProperty(stack1,"bg") : stack1)) != null ? lookupProperty(stack1,"full-width-row") : stack1),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":20},"end":{"line":3,"column":88}}})) != null ? stack1 : "")
    + "\">\r\n      <div class=\"column small-12\">\r\n        <div\r\n          class='outer "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"images") : depth0)) != null ? lookupProperty(stack1,"bg") : stack1)) != null ? lookupProperty(stack1,"crop-from-left") : stack1),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":23},"end":{"line":6,"column":76}}})) != null ? stack1 : "")
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"images") : depth0)) != null ? lookupProperty(stack1,"bg") : stack1)) != null ? lookupProperty(stack1,"crop-from-right") : stack1),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":77},"end":{"line":6,"column":132}}})) != null ? stack1 : "")
    + "'>\r\n          "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"images") : depth0)) != null ? lookupProperty(stack1,"bg") : stack1)) != null ? lookupProperty(stack1,"bg-img-add") : stack1),{"name":"if","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":7,"column":10},"end":{"line":10,"column":17}}})) != null ? stack1 : "")
    + "          <div class=\"content-container\">\r\n            <div class='row small-collapse'>\r\n              <div class=\"column small-12\">\r\n                <div class='inner'>\r\n                  <div class=\"content\">\r\n                    <div>\r\n                      <h2 class=\"headline cnx-light\">"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"title") || (depth0 != null ? lookupProperty(depth0,"title") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"title","hash":{},"data":data,"loc":{"start":{"line":17,"column":53},"end":{"line":17,"column":64}}}) : helper)))
    + "</h2>\r\n                      <h3 class=\"subheading cnx-light\">"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"content") || (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"content","hash":{},"data":data,"loc":{"start":{"line":18,"column":55},"end":{"line":18,"column":68}}}) : helper)))
    + "</h3>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n";
},"3":function(container,depth0,helpers,partials,data) {
    return "full-width-row small-collapse";
},"5":function(container,depth0,helpers,partials,data) {
    return "crop-from-left";
},"7":function(container,depth0,helpers,partials,data) {
    return "crop-from-right";
},"9":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " \r\n            <span class='gradients show-for-xxlarge-up'></span>\r\n            "
    + container.escapeExpression((lookupProperty(helpers,"picture")||(depth0 && lookupProperty(depth0,"picture"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"images") : depth0)) != null ? lookupProperty(stack1,"bg") : stack1),{"name":"picture","hash":{},"data":data,"loc":{"start":{"line":9,"column":12},"end":{"line":9,"column":33}}}))
    + "\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"contents") : stack1),{"name":"each","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":29,"column":9}}})) != null ? stack1 : "");
},"useData":true,"useDepths":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.sb-credit-cards.modules/product-popular-engagement-sbcc-module",
  "version": "3.0.0",
  "id": "productPopularEngagementSbccModule",
  "containerID": "sbCreditCardsProductPopularEngagementSbccModule",
  "moduleName": "sb-credit-cards-product-popular-engagement-sbcc-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "product-popular-engagement-sbcc-module",
  "data": {
    "init": "ProductPopularEngagementSbccModule",
    "options": {}
  },
  "moduleParams": [],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {
        contains,
        picture
      },
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {
    contains,
    picture
  },
  "dependencies": {
    "@sparta.credit-cards.utilities/barker-utility": "^1.0.0",
    "@sparta.global.helpers/button-helper": "^1.0.0",
    "@sparta.global.helpers/checkbox-helper": "^1.0.0",
    "@sparta.global.helpers/comparisons-helper": "^1.0.0",
    "@sparta.global.helpers/json-helper": "^1.0.0",
    "@sparta.global.helpers/picture-helper": "^1.0.0",
    "@sparta.global.helpers/radio-button-helper": "^1.0.0",
    "@sparta.sb-credit-cards.helpers/sb-credit-cards": "^2.0.0",
    "@sparta.global.helpers/secure-link-helper": "^1.0.0",
    "@sparta.global.helpers/select-helper": "^1.0.0",
    "@sparta.global.helpers/squeezebox-helper": "^1.0.0",
    "@sparta.global.helpers/star-ratings-helper": "^1.0.0",
    "@sparta.global.helpers/text-inputs-helper": "^1.0.0",
    "@sparta.global.helpers/utils-helper": "^1.0.0",
    "@sparta.sb-credit-cards.utilities/sb-credit-card-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0"
  },
  "stores": []
};

/**
 * @export
 * @class ProductPopularEngagementSbccModule
 * @extends {Module}
 */
class ProductPopularEngagementSbccModule extends Module {
  /**
  * Creates an instance
  * @param {object} options options
  * @param {object} context context
  */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
  }

  /**
   * @return {void}
   */
  init() {}
}
registerModuleClass({
  moduleClass: ProductPopularEngagementSbccModule,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { ProductPopularEngagementSbccModule as default, moduleConfig };
